module.exports = __webpack_public_path__ + "img/technology_icon_01.f6e228f5.png";